import { NgModule } from '@angular/core';
import * as fromGroups from './store/reducer';
import { CommonModule } from '@angular/common';
import { GroupsFeatureComponent } from './feature/groups-feature.component';
import { GroupsPresentersComponent } from './presenters/groups-presenters.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GroupsEffects } from './store/effects';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule, DropdownModule, RadioButtonModule } from '../shared/efaact-primeng.module';
import { SharedModule } from '../shared/shared.module';
import { GroupsAddComponent } from './presenters/groups-add/groups-add.component';
import { ExpensesModule } from '../expenses';


@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('groups', fromGroups.reducer),
        EffectsModule.forFeature([GroupsEffects]),
        EfaactMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,
        DropdownModule,
        SharedModule,
        ExpensesModule,
        RadioButtonModule
    ],
    declarations: [GroupsFeatureComponent, GroupsPresentersComponent, GroupsAddComponent]
})
export class GroupsModule { }
